import { render, staticRenderFns } from "./WhatToExpect.vue?vue&type=template&id=15019268&"
import script from "./WhatToExpect.vue?vue&type=script&lang=js&"
export * from "./WhatToExpect.vue?vue&type=script&lang=js&"
import style0 from "./WhatToExpect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports